import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Box,
  Paper,
  TextField,
  Divider,
  Chip
} from '@mui/material';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useEmpresa } from '../context/EmpresaContext';
import config from '../config';

const AprobarServicioDialog = ({ open, onClose, servicio, onApproveSuccess }) => {
  const [glosa, setGlosa] = useState('');
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const { simboloMoneda } = useEmpresa();

  if (!servicio) return null;

  const formatCurrency = (value) => {
    const formatted = parseFloat(value || 0).toLocaleString('es-PE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return `${simboloMoneda} ${formatted}`;
  };

  const handleApprove = async () => {
    setLoading(true);
    try {
      const response = await axios.put(
        `${config.API_BASE_URL}/api/approve-services/aprobar/${servicio.id_asignacion}`,
        { glosa },
        {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        }
      );

      if (response.status === 200) {
        onApproveSuccess && onApproveSuccess();
        onClose();
      }
    } catch (error) {
      console.error('Error al aprobar el servicio:', error);
      alert('Error al aprobar el servicio');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Aprobar Servicio - Orden #{servicio.id_orden_servicio}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper elevation={0} variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom>Información del Servicio</Typography>
              <Box sx={{ mt: 1 }}>
                <Typography><strong>Cliente:</strong> {servicio.nombre_cliente} {servicio.apellido_cliente}</Typography>
                <Typography><strong>Local:</strong> {servicio.nombre_local || 'No especificado'}</Typography>
                <Typography><strong>Tipo:</strong> {servicio.tipo_servicio || 'No especificado'}</Typography>
                <Typography><strong>Fecha:</strong> {new Date(servicio.fecha_orden).toLocaleDateString()}</Typography>
                <Typography><strong>Estado:</strong> {servicio.nombre_estado_servicio}</Typography>
                
                <Box sx={{ mt: 2 }}>
                  <Chip 
                    label={`Precio: ${formatCurrency(servicio.precio_servicio || 0)}`} 
                    color="primary" 
                    sx={{ mr: 1, mb: 1 }}
                  />
                  <Chip 
                    label={`Comisión: ${formatCurrency(servicio.comision || 0)}`} 
                    color="secondary"
                    sx={{ mb: 1 }}
                  />
                </Box>
              </Box>
            </Paper>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Paper elevation={0} variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom>Información del Trabajador</Typography>
              <Box sx={{ mt: 1 }}>
                <Typography><strong>Nombre:</strong> {servicio.nombre_trabajador} {servicio.apellido_trabajador}</Typography>
              </Box>
            </Paper>
          </Grid>
          
          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" gutterBottom>Comentarios para la aprobación</Typography>
            <TextField
              fullWidth
              multiline
              rows={3}
              variant="outlined"
              placeholder="Comentarios sobre la aprobación del servicio..."
              value={glosa}
              onChange={(e) => setGlosa(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button 
          onClick={handleApprove} 
          variant="contained" 
          color="primary"
          disabled={loading}
        >
          {loading ? 'Aprobando...' : 'Aprobar Servicio'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AprobarServicioDialog;